import { render, staticRenderFns } from "./chat-operate-bar.vue?vue&type=template&id=60f05f47&"
import script from "./chat-operate-bar.vue?vue&type=script&lang=js&"
export * from "./chat-operate-bar.vue?vue&type=script&lang=js&"
import style0 from "./chat-operate-bar.vue?vue&type=style&index=0&id=60f05f47&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports